<button class="back-button"
        (click)="close()">
  <i class="far fa-arrow-circle-left"></i>
  <div class="back-text"
       translate="MODAL.BACK"></div>
</button>

<div class="tabs">
  <button *ngFor="let tab of tabs"
          [routerLink]="tab.route"
          class="dialog-nav"
          routerLinkActive="active"
          [translate]="tab.name"></button>
</div>
